export default __webpack_public_path__ + "static/media/alipayhk_logo.de0e0db9.svg";